export default __webpack_public_path__ + "static/media/double_panna.622f909b.png";